import React from 'react';
import { QuestionVideo } from '@ovos-media/templates/dist/sp';
import { generateUrl } from '../domains/uploads';

export default ({ file_video_id, ...props }) => (
  <QuestionVideo
    {...props}
    videoSource={generateUrl(file_video_id)}
  />
);